<template>
  <PerkContainer is-raw-clickable screen-reader-label="Select Protection Plan" data-testid="wnm-banner" @value-info-click="openWnmSlideout">
    <template #icon>
      <Icon :icon="csgAtYourService" size="m" theme="dark" class="icon icon-left" :aria-label="bannerDisplay.iconAltText" />
    </template>
    <div class="wnm-perk">
      <div class="wnm-title large">
        {{ bannerDisplay.title }}
      </div>
      <div class="wnm-subtitle">
        {{ bannerDisplay.subtitle }}
      </div>
    </div>
    <template v-if="selectedPlan" #tooltip>
      <div class="wnm-trailing">
        <WnmPrice :price="selectedPlan.wnmUnitFee" :quantity :is-big-ticket-item="isProductBigTicket" />
        <i
          :class="[
            'tooltip icon',
            {
              'tool-tip-dark-medium': isProductPerksEnabled,
              'chevron-large-right-dark-small': isProductPerksEnabledPhase2,
            },
          ]"
          aria-hidden="true"
        ></i>
      </div>
    </template>
    <!-- loads while fetch is in progress -->
    <Teleport defer to="body">
      <LoaderOverlay :show-overlay="showLoader" />
    </Teleport>
  </PerkContainer>
</template>

<script setup>
import { computed } from 'vue';

import Icon from '@atomic-ui/icon/Icon';
import LoaderOverlay from '@atomic-ui/loaderOverlay/LoaderOverlay.vue';
import { csgAtYourService } from '@csgSvgIcons/icons';
import PerkContainer from '~/modules/productPerks/components/PerkContainer';
import useFeatureEligibility from '~/modules/featureControl/composables/useFeatureEligibility';
import { useQuantity } from '~/modules/product/composables/useQuantity';
import WnmPrice from '~/modules/worry-no-more/components/WnmPrice.vue';
import { useWnm } from '~/modules/worry-no-more/composables/useWnm';
import useWnmSlideout from '~/modules/worry-no-more/composables/useWnmSlideout';

const { selectedPlan, isProductBigTicket } = useWnm();
const { openWnmSlideout, showLoader } = useWnmSlideout();
const { quantity } = useQuantity();
const { isProductPerksEnabled, isProductPerksEnabledPhase2 } = useFeatureEligibility();

const bannerDisplay = computed(() => {
  const plan = selectedPlan.value;
  return {
    iconAltText: plan ? 'Allstate protection plan selected' : 'Allstate protection',
    title: plan ? plan.name : 'Add an Allstate Protection Plan',
    subtitle: 'Worry-free coverage for your purchase',
  };
});
</script>

<style lang="scss" scoped>
@import '~settingSCSS';

.wnm-perk {
  overflow: hidden;
}

.wnm-title {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-clamp: 2;
  margin-bottom: rem-calc(4);
}

.wnm-subtitle {
  color: $gray-1-color;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-clamp: 2;
}

.wnm-trailing {
  display: flex;
  align-items: center;
  margin-left: auto;
  flex-shrink: 0;
  gap: rem-calc(8);
}

.wnm-trailing :deep(.wnm-price) {
  white-space: nowrap;
  flex-shrink: 0;
}
</style>
